export default "__VITE_ASSET__bLDlJrD1__"